import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router";
import { RootState } from "../../redux/rootReducer";

export interface IPrivateRouteProps extends RouteProps {
  Layout?: any;
}

const PrivateRoute: React.FC<IPrivateRouteProps> = (props) => {
  const { isAuth } = useSelector(
    ({ auth }: RootState) => ({
      isAuth: auth.user != null,
    }),
    shallowEqual
  );

  const { Layout, component } = props;

  return isAuth ? (
    Layout ? (
      <Layout>
        <Route {...props} component={component} render={undefined} />
      </Layout>
    ) : (
      <Route {...props} component={component} render={undefined} />
    )
  ) : (
    <Redirect to="/auth/login" />
  );
};

export default PrivateRoute;
